export default __webpack_public_path__ + "static/media/ICON12.99e34828.svg";